/**
 * PD Analytics laag 1b (28-08-2026): anonieme event-telling.
 * AVG/ePrivacy-ontwerp, bewust zonder consent laadbaar:
 * - GEEN cookies, GEEN localStorage/sessionStorage, GEEN bezoekers-id
 * - geen IP/volledige user-agent opgeslagen (Worker bewaart alleen mobile/desktop)
 * - referrer alleen als hostnaam (volledige URL kan persoonsdata bevatten)
 * - events zijn losse tellingen, niet aan elkaar of aan sessies te koppelen
 * Transport: sendBeacon via de door Shopify ondertekende app proxy
 * (/apps/primerdeck/event, ALTIJD zonder taal-prefix).
 */
(function pdEvents() {
  var API = '/apps/primerdeck/event';
  var queue = [];
  var timer = null;

  function flush() {
    if (!queue.length) return;
    var batch = queue.splice(0, 20);
    try {
      navigator.sendBeacon(API, new Blob([JSON.stringify({ events: batch })], { type: 'application/json' }));
    } catch (_) { /* telemetrie is optioneel; nooit de site hinderen */ }
  }

  function track(name, meta) {
    if (!/^[a-z0-9_]{1,40}$/.test(name)) return;
    queue.push({
      n: name,
      p: location.pathname.slice(0, 200),
      m: String(meta == null ? '' : meta).slice(0, 80)
    });
    if (queue.length >= 15) { flush(); return; }
    clearTimeout(timer);
    timer = setTimeout(flush, 10000);
  }
  window.pdEvent = track;
  addEventListener('pagehide', flush);

  // Pageview + alleen de HOSTNAAM van de verwijzer
  var ref = '';
  try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (_) {}
  track('pageview', ref);

  // Scrolldiepte, per drempel maximaal 1x per paginaweergave
  var seen = {};
  addEventListener('scroll', function () {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (max <= 0) return;
    var pct = (scrollY / max) * 100;
    [25, 50, 75, 100].forEach(function (d) {
      if (pct >= d && !seen[d]) { seen[d] = 1; track('scroll_' + d); }
    });
  }, { passive: true });

  // Gebeurtenissen via event-delegation; niets persoonlijks in de meta
  addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!el) return;
    if (el.classList.contains('pd-wishlist-btn')) {
      return track(el.hasAttribute('data-pd-saved') ? 'wishlist_remove' : 'wishlist_add');
    }
    if (el.classList.contains('add-to-cart-button') || (el.name === 'add' && el.closest('product-form-component'))) {
      return track('add_to_cart');
    }
    if (el.name === 'checkout' || (el.getAttribute && /\/checkout/.test(el.getAttribute('href') || ''))) {
      return track('begin_checkout');
    }
    if (el.classList.contains('pd-quiz-answer')) return track('quiz_answer');
    if (el.closest('[data-quiz-result]')) return track('quiz_result_click');
    if (el.classList.contains('pd-lib-chip')) return track('library_filter');
    if (el.classList.contains('pd-btn') || el.classList.contains('button')) {
      return track('cta_click', (el.textContent || '').trim().slice(0, 40));
    }
  }, { capture: true, passive: true });

  // Zoekgebruik: alleen DAT er gezocht is + lengte, niet de term zelf
  addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/search/.test(f.getAttribute('action') || '')) {
      var q = f.querySelector('input[name="q"]');
      track('search_used', q ? String((q.value || '').length) : '');
    }
  }, { capture: true, passive: true });
})();
